module.exports = __webpack_public_path__ + "img/order-color-icon.b6c764ab.svg";